import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import Http from "../../../Http";
import GuiasSelect from './GuiasSelect';
import moment from "moment";
import { withRouter } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, CircularProgress, Button } from "@material-ui/core";

class FacturarCredito extends FormComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      loadingPreview: false,
      openPreviewModal: false,
      previewUrl: "",
    };
  }
  componentDidMount() {
    this.FormConfig(
      { defaultUrl: "corte/one", saveUrl: "corte/save", backUrl: "/Catalogo" },
      new Form(
        [
          Form.Field("hidden", "id_guia", "", "", []),
          Form.Field("hidden", "folio", "Folio Factura", "", [], 12, [], [], [], false, true),
          Form.Field("hidden", "FFO", "Folio", "", [], 12, [], [], [], false, true),
          Form.Field("date", "start_date", "Fecha inicial", new Date(2015, 1, 1), [], 6),
          Form.Field("date", "end_date", "Fecha final", new Date(), [], 6),
          Form.Field("autocomplete", "cliente", "Cliente", "", [], 12),
          Form.Field("hidden", "concepto", "Concepto manual", "", [], 12),
          Form.Field("select", "cliente_cfdi_uso", "Uso CFDi", "", [Validators.required], 4),
          Form.Field("select","cliente_forma_pago","Forma de pago","",[Validators.required], 4),
          Form.Field("select", "cliente_metodo_pago", "Metodo de pago", "", [Validators.required], 4),
          Form.Field("checkbox", "flete_logistico", "Reemplazar Flete x Servicio Logistico", false, [], 6),
        ],
        ["Buscar guias"],
        "Facturar Credito"
      ),
      this.formData
    ).then(() => {
      if (this.props.match.params.id) {
        this.LoadPreds();
      }
    })
  }

  LoadPreds = async () => {
    let id = this.props.match.params.id;
    let Res = await Http.get(`facturacion/factura-info/${id}`);
    if (!Res.error) {
      let formData = this.state.FormData;
      const { data } = Res;
      let disabled = false;
      formData = Form.FieldOptions(formData, "cliente", [{ id: data.id_cliente, cliente: data.receptor_razon_social }], "id", "cliente");
      formData = Form.FieldMod(this.state.FormData, 'cliente', "Disabled", true);
      formData = Form.FieldMod(this.state.FormData, 'folio', "Type", "text");
      formData = Form.Patch(formData, {
        concepto: data.desc_manual,
        cliente_cfdi_uso: data.receptor_id_uso_cfdi,
        cliente_forma_pago: data.id_forma_pago,
        cliente_metodo_pago: data.id_metodo_pago,
        cliente: data.id_cliente,
        folio: data.tipo_cons,
        FFO: data.FFO
      });
      if (data.timbrado == true) {
        formData = Form.FieldMod(this.state.FormData, 'start_date', "Type", "hidden");
        formData = Form.FieldMod(this.state.FormData, 'end_date', "Type", "hidden");
        formData = Form.FieldMod(this.state.FormData, 'FFO', "Type", "text");
        formData = Form.FieldMod(this.state.FormData, 'cliente_cfdi_uso', "Disabled", true);
        formData = Form.FieldMod(this.state.FormData, 'cliente_forma_pago', "Disabled", true);
        formData = Form.FieldMod(this.state.FormData, 'cliente_metodo_pago', "Disabled", true);
        disabled = true;
      }
      const start_date = moment(new Date(2015, 1, 1)).format('YYYY-MM-DD');
      const end_date = moment().format('YYYY-MM-DD');
      let guias = data.guias.map(g => g.guia_id);
      this.setState({ 
        FormData: formData, 
        id_cliente: data.id_cliente, 
        start_date, 
        end_date, 
        id: data.id, 
        guias, 
        disabled,
        timbrado: data.timbrado,
      });
    }
    return Res.data;
  }


  formData = async (form) => {
    let newForm = form;
    this.initial = true;
    const Res = await Http.get(`facturacion/form?initialdata=${this.initial}&cliente=${this.clienteSearch}`);
    if (!Res.error) {
      const { clientes,  formas_pago, metodos_pago, cfdi_usos } = Res.data;
      this.clienteSearch = false;
      if (clientes) {
        newForm = Form.FieldOptions(newForm,"cliente",clientes,"id","cliente");
      }
      if (cfdi_usos) {
        newForm = Form.FieldOptions(newForm,"cliente_cfdi_uso",cfdi_usos,"id","cfdi_uso_nombre");
      }
      if (formas_pago) {
        newForm = Form.FieldOptions(newForm,"cliente_forma_pago",formas_pago,"id","forma_nombre");
      }
      if (metodos_pago) {
        newForm = Form.FieldOptions(newForm,"cliente_metodo_pago",metodos_pago,"id","metodo_nombre");
      }
    }
    newForm = Form.ValueChange(newForm, {
      cliente: this.searchCliente,
      concepto: this.conceptoChange,
    });
    this.initial = false;
    return newForm;
  };

  conceptoChange = (field) => {
    this.setState({ concepto_manual: field.Value });
  }

  searchCliente = async (field) => {
    if (field.Value) {
      let Resp = await Http.get(`cliente/one/${field.Value}`);
      if (!Resp.error) {
        const { cliente_fc_concepto, cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago, cliente_rsocial, cliente } = Resp.data;
        let formData = this.state.FormData;
        if (cliente_fc_concepto) {
          formData = Form.FieldMod(formData, 'concepto', 'Type', 'textarea')
        } else {
          formData = Form.FieldMod(formData, 'concepto', 'Type', 'hidden')
          formData = Form.FieldMod(formData, 'concepto', 'Value', '')
        }
        formData = Form.FieldMod(formData, 'cliente', 'ValueAt', `${cliente} - ${cliente_rsocial}`)
        formData = Form.Patch(formData, {  cliente_cfdi_uso,  cliente_forma_pago,  cliente_metodo_pago }, false);
        this.setState({ FormData: formData });
      }
    } else {
      this.clienteSearch = field.ValueAt;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  };

  onSubmit = async (i, vals) => {
    const start_date = moment(vals['start_date']).format('YYYY-MM-DD');
    const end_date = moment(vals['end_date']).format('YYYY-MM-DD');
    const id_cliente = this.state.id_cliente ? this.state.id_cliente : vals['cliente']
    this.setState({ id_cliente, start_date, end_date, vals });
  };

  onChangeGuias = (guias) =>  {
    this.setState({ guias });
  }

   facturar = async (timbrar) => {
    const { guias, id, disabled } = this.state;
    if (disabled) {
      return;
    }
    this.setState({ loading: true });
    let vals = {};
    for (const field of this.state.FormData.Fields) {
      vals[field.Name] = field.Value;
    }
    vals = { ...vals, guias, id, timbrar };
    const Resp = await Http.post("facturacion/facturar-credito", vals);
    if (!Resp.error) {
      this.props.history.push(`/Ventas/FacturarCreditoV1/${Resp.data.id}`);
      window.location.reload();
    } else {
      this.setState({ loading: false, sbOpen: true, sbMsg: Resp.errMsg });
    }
  };

  previsualizar = async () => {
    const { guias, id, disabled } = this.state;
    if (disabled) {
      return;
    }
    this.setState({ loadingPreview: true });
    
    let vals = {};
    for (const field of this.state.FormData.Fields) {
      vals[field.Name] = field.Value;
    }
    vals = { ...vals, guias, id, timbrar: false };
    
    try {
      const Resp = await Http.post("facturacion/facturar-credito", vals);
      if (!Resp.error) {
        const previewId = Resp.data.id;
        
        if (!id) {
          this.setState({ id: previewId });
          this.props.history.replace(`/Ventas/FacturarCreditoV1/${previewId}`);
        }
        
        const pdfResp = await Http.post(
          "facturacion/file",
          { factura_id: previewId, type: "pdf" },
          true,
          "arraybuffer"
        );
        
        if (pdfResp && !pdfResp.error) {
          const blob = new Blob([pdfResp], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          this.setState({ previewUrl: url, openPreviewModal: true, loadingPreview: false });
        } else {
          this.setState({ loadingPreview: false, sbOpen: true, sbMsg: pdfResp.errMsg || "Error al generar PDF de vista previa" });
        }
      } else {
        this.setState({ loadingPreview: false, sbOpen: true, sbMsg: Resp.errMsg });
      }
    } catch (e) {
      console.error(e);
      this.setState({ loadingPreview: false, sbOpen: true, sbMsg: "Error inesperado durante la vista previa" });
    }
  };

  render() {
    const { id_cliente, start_date, end_date, vals = {}, concepto_manual, id, guias, loading, disabled, timbrado, loadingPreview, openPreviewModal, previewUrl } = this.state;
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, padding: '12px 16px', background: '#e3f2fd', borderRadius: '8px', border: '1px solid #90caf9' }}>
          <div>
            <strong style={{ color: '#1565c0' }}>💡 Estás en la Versión Anterior (V1) de Facturación a Crédito</strong>
            <span style={{ marginLeft: 8, fontSize: '0.9em', color: '#555' }}>
              Hay una nueva versión (V2) disponible con un flujo mejorado.
            </span>
          </div>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              const currentId = id || this.props.match.params.id;
              this.props.history.push(`/Ventas/FacturarCredito${currentId ? `/${currentId}` : ''}`);
            }}
          >
            🚀 Probando Nueva Versión (V2)
          </Button>
        </div>
        <this.FormRender />
        { id_cliente &&
          <GuiasSelect 
            timbrado={timbrado}
            id={id}
            id_cliente={id_cliente} 
            start_date={start_date} 
            end_date={end_date} 
            guias={guias}
            vals={{ ...vals, concepto: concepto_manual }} 
            facturar={this.facturar}
            previsualizar={this.previsualizar}
            onChangeGuias={this.onChangeGuias}
            loading={loading}
            loadingPreview={loadingPreview}
            disabled={disabled}
          />
        }
        
        <Dialog
          open={openPreviewModal || false}
          onClose={() => this.setState({ openPreviewModal: false })}
          fullWidth={true}
          maxWidth="lg"
        >
          <DialogTitle style={{ display: "flex", alignItems: "center" }}>
            <strong>Vista Previa de la Factura (Borrador)</strong>
            <Button 
              variant="outlined" 
              color="secondary" 
              onClick={() => this.setState({ openPreviewModal: false })}
              style={{ marginLeft: "auto" }}
            >
              Cerrar
            </Button>
          </DialogTitle>
          <DialogContent dividers style={{ height: "75vh", padding: 0 }}>
            {previewUrl ? (
              <iframe
                src={previewUrl}
                title="Vista Previa de Factura"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            ) : (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <CircularProgress />
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(FacturarCredito);
